export function scoreOptions() {
  return [1, 2, 3, 4, 5]
}
